import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { DescriptionText, IconBackground, ModalButtonsContainer, PaymentModal, TitleText } from "../../PaymentComponents";
import { StyledModalBody } from "../../../../components/Modals";
import { Flex } from "../../../../components/ui/Flex";
import { ButtonBodyVariant } from "../../../../components/ui/ButtonVariant";
import { closeActiveModal } from "../../../../helper/modals";
import { Palette } from "../../../../components/utils";
import { IoMdCheckmark } from "react-icons/io";
import {
  getVopayBlockedAccountMessageKey,
  getVopayBlockedStatusLabel,
  isOnboardingBlockedMessageType,
  ONBOARDING_MODAL_MESSAGE,
  resolveVopayOnboardingLink,
  VOPAY_ORG_APPLICATION_PENDING_CONTACT_SUPPORT_MESSAGE
} from "../../PaymentUtils";

const ORG_SETUP_DESCRIPTION =
  'To enable payouts, please take a moment to set up your VoPay account in the admin portal. It will take about 20 minutes to complete the setup process.';

const VOPAY_PENDING_APPROVAL_MESSAGE =
  'Your application for VoPay is pending. Please wait for Vopay to approve your application.';

const OnboardingModal = () => {
  const { t } = useTranslation();
  const { modal, data } = useSelector((state) => state.headerModal);
  const messageType = data?.messageType;
  const showSetupAction = messageType === ONBOARDING_MODAL_MESSAGE.ORG_SETUP;
  const setupLink = showSetupAction ? resolveVopayOnboardingLink(data?.link) : '';

  const description = (() => {
    if (messageType === ONBOARDING_MODAL_MESSAGE.ORG_SETUP) {
      return t(ORG_SETUP_DESCRIPTION);
    }
    if (messageType === ONBOARDING_MODAL_MESSAGE.ORG_CONTACT_SUPPORT) {
      return t(VOPAY_ORG_APPLICATION_PENDING_CONTACT_SUPPORT_MESSAGE);
    }
    if (isOnboardingBlockedMessageType(messageType)) {
      return t(getVopayBlockedAccountMessageKey(messageType), {
        status: getVopayBlockedStatusLabel(data?.status)
      });
    }
    return t(VOPAY_PENDING_APPROVAL_MESSAGE);
  })();

  return (
    <PaymentModal
      show={modal === 'OnboardingModal'}
      onClose={closeActiveModal}
      closeOnBackdrop={false}
      width={'460px'}
      padding={"2.25rem 1.5rem 3rem 1.5rem"}
    >
      <StyledModalBody>
        <Flex direction="column" alignItems="center" gap="1.5rem">
          <IconBackground background={Palette.GREEN_500}>
            <IoMdCheckmark size={32} color={Palette.WHITE} style={{ position: "absolute", right: "12px", top: "11px" }} />
          </IconBackground>
          <Flex direction="column" alignItems="center" gap="1rem">
            <TitleText lg>{t('Set Up VoPay')}</TitleText>
            <DescriptionText>{description}</DescriptionText>
          </Flex>
          <ModalButtonsContainer gapY="8px" column>
            {showSetupAction && setupLink && (
              <a href={setupLink} target="_blank" rel="noopener noreferrer">
                <ButtonBodyVariant cssOverride={"width: 100%;"}>{t('Set up')}</ButtonBodyVariant>
              </a>
            )}
            <ButtonBodyVariant variant="secondary" onClick={closeActiveModal} cssOverride={"width: 100%;"}>
              {t('Cancel')}
            </ButtonBodyVariant>
          </ModalButtonsContainer>
        </Flex>
      </StyledModalBody>
    </PaymentModal>
  );
};

export default OnboardingModal;
